import { LoadIdView } from '../../../../models';

export class ShipmentLoadOverviewLoad {
  public static readonly type = '[ShipmentLoadOverview] Load Overview';
  constructor(public payload: LoadIdView) {}
}

export class ShipmentLoadOverviewSetInitialState {
  public static readonly type = '[ShipmentLoadOverview] Set Initial State';
}
